/**
 * FamilyMembersPage - shows list of all family members
 */

import { UsersList } from '../components/users/UsersList';

export const FamilyMembersPage = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <UsersList />
    </div>
  );
};
